import  gql  from 'graphql-tag'

export const CREATE_AMOUNT_TERMS_FA = gql`mutation amountTermsFa($input: AmountTermsFAMutationInput!){
    amountTermsFa(input: $input){
        amountTermsFA{
            id
            data
        }
        errors{
            field
            messages
        }
    }
}`;